import {create} from 'zustand';

import {ModalOtpConfirmationStateStore} from './types';
import {DEFAULT_OTP_MODAL_STATE_STORE} from './constants';

export const useModalOtpConfirmationStateStore = create<ModalOtpConfirmationStateStore>(
	(set, get) => ({
		state: DEFAULT_OTP_MODAL_STATE_STORE,
		updateState: partial =>
			set({
				state: {
					...get().state,
					...partial,
				},
			}),
		reset: () => set({state: DEFAULT_OTP_MODAL_STATE_STORE}),
	}),
);
